// extracted by mini-css-extract-plugin
export default {"link":"Link_link__DnnKh","icon":"Link_icon__D+wmA","disabled":"Link_disabled__KKPhl","error-text":"Link_error-text__VXFpp"};